export default __webpack_public_path__ + "static/media/mode-501.4c244b60.svg";